export default "__VITE_ASSET__ddb29bba__"